<template>
    <div>
        <section>
            <div class="container">
                <div class="text-title">CSA<sup>&reg</sup> F280-12 Residential Heating and Cooling Loads</div>
                <p>
                    LoopCAD and HeatCAD provide for easy, accurate and verified CSA F280-12 residential heating and cooling load calculations.
                    The Professional and MJ8 Editions of these programs have been specifically designed and tested for the latest CSA F280-12 (R2021 Update 3)
                    standard, and have been verified by HVAC Designers of Canada.<a href="http://hvacdc.ca.previewyoursite.com/?page_id=406" target="_blank" runat="server">Click here for the verified listing webpage.</a>
                </p>
                <div class="row justify-center items-center" :class="{'q-mb-xl' : screenSize.lt.sm}">
                    <div class="col-xs-12 col-sm-auto text-center">
                        <img class="img-acca" :src="require('@/assets/img/content/f280-verified.png')">
                    </div>
                    <div class="col-xs-12 col-sm-auto q-gutter-md">
                        <div class="row justify-center">
                            <img class="img-logo" :src="require('@/assets/img/logos/product/loopcad-mj8.png')">
                        </div>
                        <div class="row justify-center">
                            <img class="img-logo" :src="require('@/assets/img/logos/product/heatcad-mj8.png')">
                        </div>
                    </div>
                </div>
                <p>
                    Users of the Professional and MJ8 Editions are strongly encouraged to purchase a copy of the CSA F280-12
                    standard to use in conjunction with the software. Visit <a href="https://www.csagroup.org/store/" target="_blank">www.csagroup.org/store</a> for
                    purchasing information.
                </p>
                <p>
                    The following highlights key features in the Professional and MJ8 Editions for both LoopCAD and HeatCAD. For a detailed comparison
                    of features go to the <router-link to="product/loopcad">LoopCAD Features</router-link> page or the
                    <router-link to="product/heatcad">HeatCAD Features</router-link> page
                </p>
            </div>
        </section>

        <features :productLine="f280" />
    </div>
</template>
<script>
    import features from '@/components/ProductFeatures'
    import { F280 } from '@/plugins/f280'
    export default {
        name: 'f280',
        components: {
            features,
        },
        data() {
            return {
                f280: F280,
            }
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-xs-max) {
        .img-logo {
            max-height: 55px;
        }

        .img-acca {
            max-height: 250px;
        }
    }
</style>
